import { globalVariables } from "helper/globalVariables";
import { Button } from "shared/Components/button";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import moment from "moment";

export const UserListCard = ({ userDetail, onViewMoreClick }) => {
  return (
    <div class="bg-white p-4 flex flex-col flex-1 result-card-box">
      <div className="flex flex-col">
        <div className="flex flex-row justify-between">
          <span class="text-lg font-semibold text-gray-900">
            {userDetail.location}
          </span>
        </div>

        <span class="text-sm text-gray-600 font-semibold">
          {userDetail.level}
        </span>
      </div>
      <div className="pt-8 flex justify-between items-center">
        <span class="text-sm text-gray-600 font-semibold">
          {moment(userDetail.date).format(DEFAULT_DATE_FORMAT)}
        </span>
        <Button
          label={globalVariables.viewMore}
          width="w-32"
          onClick={onViewMoreClick}
        />
      </div>
    </div>
  );
};
